/*
 * Description of what this file is for
 *
 * @package  craft3
 * @author Stefan Prosch [hello@stefanprosch.com]
 * waterTemperature
 */

import $ from 'jquery';

const waterTemperature = {
    cfg: {
        wrapper: document.querySelectorAll('.js-waterTemperature'),
        language: 'de',
    },

    init() {
        window.addEventListener('load', () => {
            if (this.cfg.wrapper) {
                /* eslint-disable */
                // Get Wassertemperatur
                $.getJSON('/weather/latest_temperature.json', (data) => {
                    this.cfg.wrapper.forEach((wrapper) => {
                        // Manipulate Current Temperature
                        wrapper.querySelector('.js-currentWaterTemp').innerHTML = `${Math.round(data.water*10)/10}&deg;C`.replace('.', ',');
                    });
                });
                /* eslint-enable */
            }
        });
    }
};

export default waterTemperature;



// WEBPACK FOOTER //
// ./___src/templates/_molecules/waterTemperature/_script.js